import { render, staticRenderFns } from "./initiate-my.vue?vue&type=template&id=4cb22ca8&scoped=true&"
import script from "./initiate-my.vue?vue&type=script&lang=js&"
export * from "./initiate-my.vue?vue&type=script&lang=js&"
import style0 from "./initiate-my.vue?vue&type=style&index=0&id=4cb22ca8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb22ca8",
  null
  
)

export default component.exports